module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Eolian","short_name":"eluize-releases","start_url":"/","background_color":"#000000","theme_color":"#FF0000","display":"minimal-ui","icon":"src/images/bird-head.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"032d85f03bd07719a062ccc69e2c8d6b"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
